// Written in this round about way for babel-transform-imports
import StaticRouter from 'react-router/es/StaticRouter';

export default StaticRouter;


//////////////////
// WEBPACK FOOTER
// /home/builder/buildbot/microupdate/PLESK_17_8-cl7/build/buck-out/gen/~/node_modules/react-router-dom/es/StaticRouter.js
// module id = 48
// module chunks = 1 2 3 4 5